import {Route, createRoutesFromElements, createBrowserRouter} from "react-router-dom";
import * as Sentry from "@sentry/react";

import {CustomDomainType} from "platformed-client/types";
import BubbleError from "./BubbleError";
import {setRouter} from ".";
import {ReactNode} from "react";
import {unreachableCase} from "../utils/typescript";
import {domainType} from "../utils/environment";
import {retryImport} from "../utils/retryImport";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

interface DynamicRouter {
  default: ReactNode;
}

function importRoutesFromDomainType(domainType: CustomDomainType | null): Promise<DynamicRouter> {
  switch (domainType) {
    case "TrustCenter":
      return import("../TrustCenter");
    case "Collect":
      return import("../Collect");
    case null:
      return import("../App/appRoutes");
    default:
      unreachableCase(domainType);
  }
}

export async function initRouter() {
  const routes = (await retryImport(() => importRoutesFromDomainType(domainType))).default;
  const router = sentryCreateBrowserRouter(
    createRoutesFromElements(
      <Route path="/" errorElement={<BubbleError />}>
        {routes}
      </Route>,
    ),
    {future: {v7_relativeSplatPath: true}},
  );
  setRouter(router);
}
